import { request } from "./request";

const BASE_URL = "/api/work_experience";

export default {
  async create(data) {
    return await request({
      method: "POST",
      url: BASE_URL,
      data: {
        description: data.description,
        role: data.role,
        company: data.company,
        from: data.from,
        to: data.to,
        company_city: data.companyCity,
      },
    });
  },

  async update(experience, data) {
    return await request({
      method: "PUT",
      url: `${BASE_URL}/${encodeURIComponent(experience.id)}`,
      data: {
        description: data.description,
        role: data.role,
        company: data.company,
        from: data.from,
        to: data.to,
        company_city: data.companyCity,
      },
    });
  },

  async delete(experience) {
    return await request({
      method: "DELETE",
      url: `${BASE_URL}/${encodeURIComponent(experience.id)}`,
    });
  },

  async companies(value) {
    if (!value) {
      return Promise.resolve([]);
    }
    return await request({
      method: "GET",
      url: `${BASE_URL}/companies?value=${encodeURIComponent(value)}`,
    });
  },
};
